var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/poaBridge/index.ts
var poaBridge_exports = {};
__export(poaBridge_exports, {
  BlockchainEnum: () => BlockchainEnum,
  PoaBridgeNetworkReference: () => PoaBridgeNetworkReference,
  VirtualNetworkReference: () => VirtualNetworkReference,
  createWithdrawMemo: () => createWithdrawMemo,
  getPendingDeposits: () => getPendingDeposits,
  httpClient: () => poaBridgeHttpClient_exports,
  waitForWithdrawalCompletion: () => waitForWithdrawalCompletion
});

// src/poaBridge/poaBridgeHttpClient/index.ts
var poaBridgeHttpClient_exports = {};
__export(poaBridgeHttpClient_exports, {
  getDepositAddress: () => getDepositAddress,
  getDepositStatus: () => getDepositStatus,
  getSupportedTokens: () => getSupportedTokens,
  getTokenBalancesRequest: () => getTokenBalancesRequest,
  getWithdrawalEstimate: () => getWithdrawalEstimate,
  getWithdrawalStatus: () => getWithdrawalStatus,
  hotOmniWithdraw: () => hotOmniWithdraw
});

// src/logger.ts
var noopLogger = {
  verbose: () => {
  },
  debug: () => {
  },
  info: () => {
  },
  warn: () => {
  },
  error: () => {
  }
};
var logger = { ...noopLogger };
function setLogger(newLogger) {
  logger = newLogger;
}

// src/config.ts
var configsByEnvironment = {
  production: {
    contractID: "intents.near",
    poaTokenFactoryContractID: "omft.near",
    poaBridgeBaseURL: "https://bridge.chaindefuser.com",
    solverRelayBaseURL: "https://solver-relay-v2.chaindefuser.com",
    managerConsoleBaseURL: "https://api-mng-console.chaindefuser.com/api/",
    nearIntentsBaseURL: "https://near-intents.org/api/"
  },
  stage: {
    contractID: "staging-intents.near",
    poaTokenFactoryContractID: "stft.near",
    poaBridgeBaseURL: "https://poa-stage.intents-near.org",
    solverRelayBaseURL: "https://solver-relay-stage.intents-near.org",
    managerConsoleBaseURL: "https://mng-console-stage.intents-near.org/api/",
    nearIntentsBaseURL: "https://stage.near-intents.org/api/"
  }
};
var config = {
  env: configsByEnvironment.production,
  features: {
    hyperliquid: false
  }
};
function configureSDK({
  logger: logger2,
  env,
  features
}) {
  if (logger2) {
    setLogger(logger2);
  }
  if (typeof env === "string") {
    config = { ...config, env: configsByEnvironment[env] };
  } else if (env) {
    config = { ...config, env };
  }
  config = {
    ...config,
    features: {
      ...config.features,
      ...features
    }
  };
}

// src/utils/request.ts
import { retry } from "@lifeomic/attempt";

// src/utils/serialize.ts
function getReferenceKey(keys, cutoff) {
  return keys.slice(0, cutoff).join(".") || ".";
}
function getCutoff(array2, value) {
  const { length } = array2;
  for (let index = 0; index < length; ++index) {
    if (array2[index] === value) {
      return index + 1;
    }
  }
  return 0;
}
function createReplacer(replacer, circularReplacer) {
  const hasReplacer = typeof replacer === "function";
  const hasCircularReplacer = typeof circularReplacer === "function";
  const cache = [];
  const keys = [];
  return function replace(key, value) {
    if (typeof value === "object") {
      if (cache.length) {
        const thisCutoff = getCutoff(cache, this);
        if (thisCutoff === 0) {
          cache[cache.length] = this;
        } else {
          cache.splice(thisCutoff);
          keys.splice(thisCutoff);
        }
        keys[keys.length] = key;
        const valueCutoff = getCutoff(cache, value);
        if (valueCutoff !== 0) {
          return hasCircularReplacer ? circularReplacer.call(
            this,
            key,
            value,
            getReferenceKey(keys, valueCutoff)
          ) : `[ref=${getReferenceKey(keys, valueCutoff)}]`;
        }
      } else {
        cache[0] = value;
        keys[0] = key;
      }
    }
    return hasReplacer ? replacer.call(this, key, value) : value;
  };
}
function serialize(value, replacer, indent, circularReplacer) {
  return JSON.stringify(
    value,
    createReplacer((key, value_) => {
      let value2 = value_;
      if (typeof value2 === "bigint")
        value2 = { __type: "bigint", value: value_.toString() };
      if (value2 instanceof Map)
        value2 = { __type: "Map", value: Array.from(value_.entries()) };
      return replacer?.(key, value2) ?? value2;
    }, circularReplacer),
    indent ?? void 0
  );
}

// src/errors/base.ts
var BaseError = class _BaseError extends Error {
  constructor(shortMessage, args = {}) {
    const details = (() => {
      if (args.cause instanceof _BaseError) return args.cause.details;
      if (args.cause != null && typeof args.cause === "object" && "message" in args.cause && typeof args.cause.message === "string") {
        return args.cause.message;
      }
      return args.details ?? "";
    })();
    const message = [
      shortMessage || "An error occurred.",
      "",
      ...args.metaMessages ? [...args.metaMessages, ""] : [],
      ...details ? [`Details: ${details}`] : []
    ].join("\n");
    super(message, args.cause ? { cause: args.cause } : void 0);
    this.name = "BaseError";
    this.details = details;
    this.metaMessages = args.metaMessages;
    this.name = args.name ?? this.name;
    this.shortMessage = shortMessage;
  }
  // biome-ignore lint/suspicious/noExplicitAny: `any` covers all overloads of `walk`
  walk(fn) {
    return walk(this, fn);
  }
};
function walk(err, fn) {
  if (fn?.(err)) return err;
  if (err && typeof err === "object" && "cause" in err && err.cause !== void 0)
    return walk(err.cause, fn);
  return fn ? null : err;
}

// src/errors/request.ts
var HttpRequestError = class extends BaseError {
  constructor({
    body,
    cause,
    details,
    headers,
    status,
    url
  }) {
    super("HTTP request failed.", {
      cause,
      details,
      metaMessages: [
        status && `Status: ${status}`,
        `URL: ${url}`,
        body && `Request body: ${serialize(body)}`
      ].filter(Boolean),
      name: "HttpRequestError"
    });
    this.body = body;
    this.headers = headers;
    this.status = status;
    this.url = url;
  }
};
var RpcRequestError = class extends BaseError {
  constructor({
    body,
    error,
    url
  }) {
    super("RPC Request failed.", {
      cause: error,
      details: error.message,
      metaMessages: [`URL: ${url}`, `Request body: ${serialize(body)}`],
      name: "RpcRequestError"
    });
    this.code = error.code;
    this.data = error.data;
  }
};
var TimeoutError = class extends BaseError {
  constructor({
    body,
    url
  }) {
    super("The request took too long to respond.", {
      details: "The request timed out.",
      metaMessages: [`URL: ${url}`, `Request body: ${serialize(body)}`],
      name: "TimeoutError"
    });
  }
};

// src/errors/utils/isNetworkError.ts
var objectToString = Object.prototype.toString;
var isError = (value) => objectToString.call(value) === "[object Error]" || value instanceof Error;
var errorMessages = /* @__PURE__ */ new Set([
  "network error",
  // Chrome
  "Failed to fetch",
  // Chrome
  "NetworkError when attempting to fetch resource.",
  // Firefox
  "The Internet connection appears to be offline.",
  // Safari 16
  "Load failed",
  // Safari 17+
  "Network request failed",
  // `cross-fetch`
  "fetch failed",
  // Undici (Node.js)
  "terminated"
  // Undici (Node.js)
]);
function isNetworkError(error) {
  if (error instanceof Error) {
  }
  const isValid = error && isError(error) && error.name === "TypeError" && typeof error.message === "string";
  if (!isValid) {
    return false;
  }
  if (error.message === "Load failed") {
    return error.stack === void 0;
  }
  return errorMessages.has(error.message);
}

// src/errors/utils/toError.ts
function toError(unknown4) {
  return unknown4 instanceof Error ? unknown4 : new Error(String(unknown4));
}

// src/utils/abortSignal.ts
function mergeAbortSignals(signals) {
  if (signals.length === 1) {
    return signals[0];
  }
  const controller = new AbortController();
  for (const signal of signals) {
    if (signal.aborted) {
      controller.abort(signal.reason);
      break;
    }
  }
  const abortHandler = (event) => {
    const signal = event.target;
    controller.abort(signal.reason);
  };
  for (const signal of signals) {
    signal.addEventListener("abort", abortHandler, { once: true });
  }
  return controller.signal;
}

// src/utils/promise/withTimeout.ts
function withTimeout(fn, {
  errorInstance = new Error("timed out"),
  timeout,
  signal
}) {
  return new Promise((resolve, reject) => {
    (async () => {
      let timeoutId;
      try {
        const controller = new AbortController();
        if (timeout > 0) {
          timeoutId = setTimeout(() => {
            if (signal) {
              controller.abort(new SpecialInternalTimeoutError());
            } else {
              reject(errorInstance);
            }
          }, timeout);
        }
        resolve(await fn({ signal: signal ? controller.signal : null }));
      } catch (err) {
        if (err instanceof SpecialInternalTimeoutError) reject(errorInstance);
        reject(err);
      } finally {
        clearTimeout(timeoutId);
      }
    })();
  });
}
var SpecialInternalTimeoutError = class extends BaseError {
  constructor() {
    super("Special internal timeout error.", {
      name: "SpecialInternalTimeoutError",
      details: "This error should be never be caught since another error instance is rethrown."
    });
  }
};

// src/utils/requestShouldRetry.ts
function requestShouldRetry(error) {
  if (error instanceof HttpRequestError && error.status != null) {
    if (error.status === 403) return true;
    if (error.status === 408) return true;
    if (error.status === 413) return true;
    if (error.status === 429) return true;
    if (error.status === 500) return true;
    if (error.status === 502) return true;
    if (error.status === 503) return true;
    if (error.status === 504) return true;
    return false;
  }
  return true;
}

// src/utils/request.ts
async function request({
  // By default, do not repeat the request, since it might not be an idempotent call
  retryOptions = { maxAttempts: 1 },
  logger: logger2,
  ...params
}) {
  const overallStartTime = performance.now();
  let totalNetworkTime = 0;
  let attemptCount = 0;
  const response = await retry(
    async (ctx) => {
      attemptCount = ctx.attemptNum + 1;
      const attemptStartTime = performance.now();
      logger2?.debug("Sending HTTP request", {
        url: params.url.toString(),
        method: params.fetchOptions?.method || "GET",
        body: JSON.stringify(params.body),
        attempt: ctx.attemptNum
      });
      const response2 = await request_(params);
      const attemptDuration = performance.now() - attemptStartTime;
      totalNetworkTime += attemptDuration;
      logger2?.debug("HTTP request attempt completed", {
        attempt: ctx.attemptNum,
        attemptDuration: Math.floor(attemptDuration),
        statusCode: response2.status,
        success: response2.ok,
        responseSize: response2.headers.get("content-length")
      });
      return response2;
    },
    {
      ...retryOptions,
      handleError: (err, context) => {
        logger2?.error("HTTP request attempt failed", {
          attempt: context.attemptNum,
          errorMessage: toError(err).message
        });
        if (!requestShouldRetry(err) || params.fetchOptions?.signal?.reason === err) {
          context.abort();
        }
      }
    }
  );
  const overallDuration = performance.now() - overallStartTime;
  const retryOverhead = overallDuration - totalNetworkTime;
  logger2?.[attemptCount > 1 ? "info" : "debug"]("HTTP request completed", {
    statusCode: response.status,
    success: response.ok,
    totalDuration: Math.floor(overallDuration),
    networkTime: Math.floor(totalNetworkTime),
    retryOverhead: Math.floor(retryOverhead),
    attempts: attemptCount,
    responseSize: response.headers.get("content-length")
  });
  return response;
}
async function request_({
  url,
  body,
  timeout = 1e4,
  fetchOptions
}) {
  const { headers, method, signal: signal_ } = fetchOptions ?? {};
  try {
    const response = await withTimeout(
      ({ signal }) => {
        return fetch(url, {
          ...fetchOptions,
          method,
          headers: {
            "Content-Type": "application/json",
            ...headers
          },
          body: JSON.stringify(body),
          signal: mergeAbortSignals(
            [signal_, timeout > 0 ? signal : null].filter(
              Boolean
            )
          )
        });
      },
      {
        errorInstance: new TimeoutError({ body, url: url.toString() }),
        timeout,
        signal: true
      }
    );
    if (!response.ok) {
      throw new HttpRequestError({
        body,
        details: response.statusText,
        headers: response.headers,
        status: response.status,
        url: url.toString()
      });
    }
    return response;
  } catch (err) {
    if (err instanceof HttpRequestError) throw err;
    if (err instanceof TimeoutError) throw err;
    if (isNetworkError(err)) {
      throw new HttpRequestError({
        body,
        cause: err,
        url: url.toString()
      });
    }
    throw err;
  }
}

// src/poaBridge/poaBridgeHttpClient/runtime.ts
import * as v2 from "valibot";

// src/utils/handleRPCResponse.ts
import * as v from "valibot";
async function handleRPCResponse(response, body, schema) {
  const json = await response.json();
  const parsed = v.safeParse(schema, json);
  if (parsed.success) {
    if (parsed.output.error !== void 0) {
      throw new RpcRequestError({
        body,
        error: parsed.output.error,
        url: response.url
      });
    }
    return parsed.output.result;
  }
  throw new RpcRequestError({
    body,
    error: { code: -1, data: json, message: "Invalid response" },
    url: response.url
  });
}

// src/utils/retry.ts
var RETRY_CONFIGS = {
  // Quick operations - API calls, database queries
  THIRTY_SECS_AGGRESSIVE: {
    delay: 500,
    minDelay: 500,
    factor: 2,
    maxAttempts: 6,
    jitter: true
  },
  // Fast services - payment processing, real-time operations
  ONE_MIN_MODERATE: {
    delay: 1e3,
    minDelay: 1e3,
    factor: 1.5,
    maxAttempts: 8,
    jitter: true
  },
  // Standard operations - withdrawals, transfers
  TWO_MINS_GRADUAL: {
    delay: 500,
    minDelay: 500,
    factor: 1.5,
    maxAttempts: 12,
    jitter: true
  },
  // Medium persistence - file processing, reports
  FIVE_MINS_STEADY: {
    delay: 2e3,
    minDelay: 2e3,
    factor: 1.4,
    maxAttempts: 12,
    jitter: true
  },
  // Long-running operations - batch jobs, imports
  THIRTY_MINS_PATIENT: {
    delay: 5e3,
    minDelay: 5e3,
    factor: 1.3,
    maxAttempts: 18,
    jitter: true
  },
  // Very long operations - large data migrations, system sync
  TWO_HOURS_PERSISTENT: {
    delay: 1e4,
    minDelay: 1e4,
    factor: 1.2,
    maxAttempts: 27,
    jitter: true
  }
};
if (void 0) {
  const { expect, test } = void 0;
  test("returns ~max attempts", () => {
    expect(calculateMaxAttempts(0, 500, 1.5)).toEqual(1);
    expect(calculateMaxAttempts(200, 500, 1.5)).toEqual(1);
    expect(calculateMaxAttempts(500, 500, 1.5)).toEqual(2);
    expect(calculateMaxAttempts(1e3, 500, 2)).toEqual(2);
    expect(calculateMaxAttempts(1500, 500, 2)).toEqual(3);
    expect(calculateMaxAttempts(750, 500, 1.5)).toEqual(2);
    expect(calculateMaxAttempts(800, 500, 1.5)).toEqual(2);
    expect(calculateMaxAttempts(2 * 60 * 60 * 1e3, 500, 1.5)).toEqual(22);
  });
}

// src/poaBridge/poaBridgeHttpClient/runtime.ts
var rpcResponseSchema = v2.union([
  // success
  v2.object({
    jsonrpc: v2.literal("2.0"),
    id: v2.string(),
    result: v2.unknown()
  }),
  // error
  v2.object({
    jsonrpc: v2.literal("2.0"),
    id: v2.string(),
    error: v2.pipe(
      v2.string(),
      v2.transform((v6) => {
        return {
          code: -1,
          data: null,
          message: v6
        };
      })
    )
  })
]);
async function jsonRPCRequest(method, params, config2) {
  const baseURL = config2?.baseURL ?? config.env.poaBridgeBaseURL;
  const url = new URL("/rpc", baseURL);
  const body = {
    id: config2?.requestId ?? "dontcare",
    jsonrpc: "2.0",
    method,
    params: params !== void 0 ? [params] : void 0
  };
  const response = await request({
    url,
    body,
    ...config2,
    fetchOptions: {
      ...config2?.fetchOptions,
      method: "POST"
    },
    retryOptions: config2?.retryOptions ?? RETRY_CONFIGS.THIRTY_SECS_AGGRESSIVE,
    logger: config2?.logger
  });
  return handleRPCResponse(response, body, rpcResponseSchema);
}

// src/poaBridge/poaBridgeHttpClient/apis.ts
async function getSupportedTokens(params, config2 = {}) {
  const result = await jsonRPCRequest(
    "supported_tokens",
    params,
    config2
  );
  return result;
}
async function getDepositAddress(params, config2 = {}) {
  const result = await jsonRPCRequest(
    "deposit_address",
    params,
    config2
  );
  return result;
}
async function getDepositStatus(params, config2 = {}) {
  const result = await jsonRPCRequest(
    "recent_deposits",
    params,
    config2
  );
  return result;
}
async function getWithdrawalStatus(params, config2 = {}) {
  const result = await jsonRPCRequest(
    "withdrawal_status",
    params,
    config2
  );
  return result;
}
async function hotOmniWithdraw(params, config2 = {}) {
  const result = await jsonRPCRequest(
    "hot_omni_withdraw",
    params,
    config2
  );
  return result;
}
async function getTokenBalancesRequest(addresses, config2 = {}) {
  const baseURL = config2.baseURL ?? config.env.poaBridgeBaseURL;
  const params = addresses.map((address) => `addresses[]=${address}`).join("&");
  const response = await request({
    url: `${baseURL}/console/tokenBalances?${params}`,
    fetchOptions: {
      method: "GET"
    }
  });
  return response.json();
}
async function getWithdrawalEstimate(params, config2 = {}) {
  const result = await jsonRPCRequest(
    "withdrawal_estimate",
    params,
    config2
  );
  return result;
}

// src/poaBridge/waitForWithdrawalCompletion.ts
import { retry as retry2 } from "@lifeomic/attempt";

// src/poaBridge/errors/withdrawal.ts
var PoaWithdrawalInvariantError = class extends BaseError {
  constructor(details, result, txHash, index) {
    super("Withdrawal is not in an expected shape.", {
      metaMessages: [
        `TxHash: ${txHash}`,
        `Index: ${index}`,
        `Result: ${serialize(result)}`
      ],
      details,
      name: "PoaWithdrawalInvariant"
    });
    this.details = details;
    this.result = result;
    this.txHash = txHash;
    this.index = index;
  }
};
var PoaWithdrawalNotFoundError = class extends BaseError {
  constructor(txHash, index, cause) {
    super("POA withdrawal not found.", {
      metaMessages: [`TxHash: ${txHash}`, `Index: ${index}`],
      name: "PoaWithdrawalNotFoundError",
      cause
    });
    this.txHash = txHash;
    this.index = index;
  }
};
var PoaWithdrawalPendingError = class extends BaseError {
  constructor(result, txHash, index) {
    super("POA withdrawal is still pending.", {
      metaMessages: [
        `TxHash: ${txHash}`,
        `Index: ${index}`,
        `Result: ${serialize(result)}`
      ],
      name: "PoaWithdrawalPendingError"
    });
    this.result = result;
    this.txHash = txHash;
    this.index = index;
  }
};

// src/poaBridge/waitForWithdrawalCompletion.ts
async function waitForWithdrawalCompletion({
  txHash,
  index = 0,
  signal,
  baseURL,
  retryOptions = RETRY_CONFIGS.TWO_MINS_GRADUAL,
  logger: logger2
}) {
  return retry2(
    async () => {
      const result = await getWithdrawalStatus(
        { withdrawal_hash: txHash },
        { baseURL, fetchOptions: { signal }, logger: logger2 }
      );
      const withdrawal = result.withdrawals[index];
      if (withdrawal == null) {
        throw new PoaWithdrawalInvariantError(
          "POA Bridge didn't return withdrawal for given index",
          result,
          txHash,
          index
        );
      }
      if (withdrawal.status === "COMPLETED") {
        if (withdrawal.data.transfer_tx_hash == null) {
          throw new PoaWithdrawalInvariantError(
            "POA Bridge didn't return transfer_tx_hash for COMPLETED withdrawal",
            result,
            txHash,
            index
          );
        }
        return {
          destinationTxHash: withdrawal.data.transfer_tx_hash,
          chain: withdrawal.data.chain
        };
      }
      throw new PoaWithdrawalPendingError(result, txHash, index);
    },
    {
      ...retryOptions,
      handleError: (err, context) => {
        if (isWithdrawalNotFound(err)) {
          if (context.attemptsRemaining > 0) {
            return;
          }
          throw new PoaWithdrawalNotFoundError(txHash, index, err);
        }
        if (err instanceof PoaWithdrawalPendingError && context.attemptsRemaining > 0) {
          return;
        }
        if (err instanceof BaseError && err.walk(
          (err2) => err2 instanceof HttpRequestError || err2 instanceof TimeoutError || err2 instanceof RpcRequestError
        )) {
          return;
        }
        context.abort();
      }
    }
  );
}
function isWithdrawalNotFound(err) {
  const RPC_ERR_MSG_WITHDRAWALS_NOT_FOUND = "Withdrawals not found";
  return err instanceof RpcRequestError && err.details === RPC_ERR_MSG_WITHDRAWALS_NOT_FOUND;
}

// src/poaBridge/constants/blockchains.ts
var PoaBridgeNetworkReference = {
  NEAR: "near:mainnet",
  ETHEREUM: "eth:1",
  BASE: "eth:8453",
  ARBITRUM: "eth:42161",
  BITCOIN: "btc:mainnet",
  SOLANA: "sol:mainnet",
  DOGECOIN: "doge:mainnet",
  XRPLEDGER: "xrp:mainnet",
  ZCASH: "zec:mainnet",
  GNOSIS: "eth:100",
  BERACHAIN: "eth:80094",
  TRON: "tron:mainnet",
  POLYGON: "eth:137",
  BSC: "eth:56",
  TON: "ton:mainnet",
  OPTIMISM: "eth:10",
  AVALANCHE: "eth:43114",
  SUI: "sui:mainnet",
  STELLAR: "stellar:mainnet",
  APTOS: "aptos:mainnet"
};
var VirtualNetworkReference = {
  TURBOCHAIN: "eth:1313161567",
  TUXAPPCHAIN: "eth:1313161573",
  VERTEX: "eth:1313161587",
  OPTIMA: "eth:1313161569",
  EASYCHAIN: "eth:1313161752",
  AURORA: "eth:1313161554"
};
var BlockchainEnum = {
  ...PoaBridgeNetworkReference,
  ...VirtualNetworkReference,
  /* Hyperliquid is only available as a withdrawal destination */
  HYPERLIQUID: "hyperliquid:999"
};

// src/poaBridge/getPendingDeposits.ts
async function getPendingDeposits(accountId) {
  const depositStatus = await getDepositStatus({
    account_id: accountId
  });
  return depositStatus.deposits.filter(
    (a) => a.status === "PENDING"
  );
}

// src/poaBridge/createWithdrawMemo.ts
function createWithdrawMemo({
  receiverAddress,
  xrpMemo
}) {
  const memo = ["WITHDRAW_TO", receiverAddress];
  if (xrpMemo != null && xrpMemo !== "") {
    memo.push(xrpMemo);
  }
  return memo.join(":");
}

// src/solverRelay/index.ts
var solverRelay_exports = {};
__export(solverRelay_exports, {
  getQuote: () => getQuote,
  publishIntent: () => publishIntent,
  publishIntents: () => publishIntents2,
  quote: () => quote,
  waitForIntentSettlement: () => waitForIntentSettlement
});

// src/solverRelay/errors/quote.ts
var QuoteError = class extends BaseError {
  constructor({
    quote: quote2,
    quoteParams
  }) {
    super("Quote error.", {
      details: quote2 == null ? "NO_QUOTE" : quote2.type,
      metaMessages: [
        `Quote: ${serialize(quote2)}`,
        `Quote params: ${serialize(quoteParams)}`
      ],
      name: "QuoteError"
    });
    this.quote = quote2;
    this.quoteParams = quoteParams;
  }
};

// src/solverRelay/solverRelayHttpClient/runtime.ts
import * as v3 from "valibot";
var rpcResponseSchema2 = v3.union([
  // success
  v3.object({
    jsonrpc: v3.literal("2.0"),
    id: v3.string(),
    result: v3.unknown()
  }),
  // error
  v3.object({
    jsonrpc: v3.literal("2.0"),
    id: v3.string(),
    error: v3.pipe(
      v3.union([
        v3.string(),
        v3.object({
          code: v3.number(),
          message: v3.string()
        })
      ]),
      v3.transform((v6) => {
        if (typeof v6 === "string") {
          return {
            code: -1,
            data: null,
            message: v6
          };
        }
        return {
          code: v6.code,
          data: null,
          message: v6.message
        };
      })
    )
  })
]);
async function jsonRPCRequest2(method, params, config2) {
  const baseURL = config2?.baseURL ?? config.env.solverRelayBaseURL;
  const url = new URL("/rpc", baseURL);
  const body = {
    id: config2?.requestId ?? "dontcare",
    jsonrpc: "2.0",
    method,
    params: params !== void 0 ? [params] : void 0
  };
  const response = await request({
    url,
    body,
    ...config2,
    fetchOptions: {
      ...config2?.fetchOptions,
      method: "POST"
    },
    retryOptions: config2?.retryOptions ?? RETRY_CONFIGS.THIRTY_SECS_AGGRESSIVE,
    logger: config2?.logger
  });
  return handleRPCResponse(response, body, rpcResponseSchema2);
}

// src/solverRelay/solverRelayHttpClient/apis.ts
async function quote(params, config2 = {}) {
  const result = await jsonRPCRequest2(
    "quote",
    params,
    config2
  );
  return result;
}
async function publishIntents(params, config2 = {}) {
  const result = await jsonRPCRequest2(
    "publish_intents",
    params,
    config2
  );
  return result;
}
async function getStatus(params, config2 = {}) {
  const result = await jsonRPCRequest2(
    "get_status",
    params,
    config2
  );
  return result;
}

// src/solverRelay/utils/quoteWithLog.ts
async function quoteWithLog(params, {
  logBalanceSufficient,
  ...config2
}) {
  const requestId = crypto.randomUUID();
  const result = await quote(params, { ...config2, requestId });
  if (result == null) {
    logger.warn("quote: No liquidity available", { quoteParams: params });
    if (logBalanceSufficient && // We don't care about fast quotes, since they fail often
    (params.wait_ms == null || params.wait_ms > 2500)) {
      logger.warn(
        "quote: No liquidity available for user with sufficient balance",
        { quoteParams: params, quoteRequestInfo: { requestId } }
      );
    }
  }
  return result;
}

// src/solverRelay/getQuote.ts
async function getQuote(params) {
  const result = await quoteWithLog(params.quoteParams, {
    // If we don't set timeout, then 10s quote will fail, since the default timeout is 10s.
    timeout: (params.quoteParams?.wait_ms ?? 0) + 1e4,
    ...params.config
  });
  return handleQuoteResult(result, params.quoteParams);
}
function handleQuoteResult(result, quoteParams) {
  if (result == null) {
    throw new QuoteError({
      quote: null,
      quoteParams
    });
  }
  const failedQuotes = [];
  const validQuotes = [];
  for (const q of result) {
    if (isValidQuote(q)) {
      validQuotes.push(q);
    } else {
      failedQuotes.push(q);
    }
  }
  const quoteKind = quoteParams.exact_amount_in !== null ? "exact_in" : "exact_out";
  const bestQuote = sortQuotes(validQuotes, quoteKind)[0];
  if (bestQuote != null) {
    return bestQuote;
  }
  const failedQuote = failedQuotes[0];
  if (failedQuote != null) {
    throw new QuoteError({
      quote: failedQuote,
      quoteParams
    });
  }
  throw new QuoteError({
    quote: null,
    quoteParams
  });
}
function sortQuotes(quotes, quoteKind) {
  return quotes.slice().sort((a, b) => {
    if (quoteKind === "exact_in") {
      if (BigInt(a.amount_out) > BigInt(b.amount_out)) return -1;
      if (BigInt(a.amount_out) < BigInt(b.amount_out)) return 1;
      return 0;
    }
    if (BigInt(a.amount_in) < BigInt(b.amount_in)) return -1;
    if (BigInt(a.amount_in) > BigInt(b.amount_in)) return 1;
    return 0;
  });
}
function isValidQuote(quote2) {
  return !("type" in quote2);
}

// src/solverRelay/publishIntents.ts
import { Err, Ok } from "@thames/monads";

// src/errors/assert.ts
var AssertionError = class extends BaseError {
  constructor(message) {
    super(message || "Assertion failed", {
      name: "AssertionError"
    });
  }
};

// src/utils/assert.ts
function assert(condition, msg) {
  if (!condition) {
    throw new AssertionError(msg);
  }
}

// src/solverRelay/utils/parseFailedPublishError.ts
var RelayPublishError = class extends BaseError {
  constructor({
    reason,
    code,
    publishParams,
    cause
  }) {
    super("Failed to publish intent.", {
      details: reason,
      metaMessages: [
        `Code: ${code}`,
        `Publish params: ${serialize(publishParams)}`
      ],
      name: "RelayPublishError",
      cause
    });
    this.name = "RelayPublishError";
    this.code = code;
  }
};
function toRelayPublishError(publishParams, response) {
  assert(response.status === "FAILED", "Expected response to be failed");
  return new RelayPublishError({
    reason: response.reason,
    code: parseFailedPublishReason(response),
    publishParams
  });
}
function parseFailedPublishReason(response) {
  assert(response.status === "FAILED", "Expected response to be failed");
  if (response.reason === "expired" || response.reason.includes("deadline has expired")) {
    return "SIGNATURE_EXPIRED";
  }
  if (response.reason === "internal") {
    return "INTERNAL_ERROR";
  }
  if (response.reason.includes("invalid signature")) {
    return "SIGNATURE_INVALID";
  }
  if (response.reason.includes("nonce was already used")) {
    return "NONCE_USED";
  }
  if (response.reason.includes("insufficient balance or overflow")) {
    return "INSUFFICIENT_BALANCE";
  }
  if (response.reason.includes("public key doesn't exist")) {
    return "PUBLIC_KEY_NOT_EXIST";
  }
  return "UNKNOWN_ERROR";
}

// src/solverRelay/publishIntents.ts
async function publishIntents2(...args) {
  const [params, requestConfig] = args;
  return publishIntents(params, {
    timeout: 3e4,
    ...requestConfig,
    retryOptions: {
      delay: 1e3,
      factor: 1.5,
      maxAttempts: 7,
      jitter: true,
      minDelay: 1e3
    }
  }).then(
    (response) => {
      return parsePublishIntentsResponse(params, response);
    },
    (err) => {
      const publishError = new RelayPublishError({
        reason: "Error occurred during sending a request",
        code: "NETWORK_ERROR",
        publishParams: params,
        cause: err
      });
      return Err(
        publishError
      );
    }
  ).then((result) => {
    if (result.isErr()) {
      const err = result.unwrapErr();
      logger.error(err);
    }
    return result;
  });
}
function parsePublishIntentsResponse(publishParams, response) {
  if (response.status === "OK") {
    return Ok(response.intent_hashes);
  }
  if (response.reason === "already processed") {
    return Ok(response.intent_hashes);
  }
  return Err(toRelayPublishError(publishParams, response));
}

// src/solverRelay/waitForIntentSettlement.ts
import { retry as retry3 } from "@lifeomic/attempt";

// src/solverRelay/errors/intentSettlement.ts
var IntentSettlementError = class extends BaseError {
  constructor(result) {
    super("Intent settlement failed.", {
      details: "Intent is published but not settled.",
      metaMessages: [
        `Status: ${result.status}`,
        `Intent hash: ${result.intent_hash}`
      ],
      name: "IntentSettlementError"
    });
    this.result = result;
  }
};

// src/solverRelay/waitForIntentSettlement.ts
async function waitForIntentSettlement({
  intentHash,
  signal,
  baseURL,
  retryOptions = RETRY_CONFIGS.TWO_MINS_GRADUAL,
  logger: logger2
}) {
  return retry3(
    async () => {
      const res = await getStatus(
        { intent_hash: intentHash },
        { baseURL, fetchOptions: { signal }, logger: logger2 }
      );
      if (res.status === "SETTLED") {
        return {
          txHash: res.data.hash,
          intentHash: res.intent_hash
        };
      }
      throw new IntentSettlementError(res);
    },
    {
      ...retryOptions,
      handleError: (err, context) => {
        if (err instanceof IntentSettlementError) {
          return;
        }
        if (err instanceof BaseError && err.walk(
          (err2) => err2 instanceof HttpRequestError || err2 instanceof TimeoutError || err2 instanceof RpcRequestError
        )) {
          return;
        }
        context.abort();
      }
    }
  );
}

// src/utils/prepareBroadcastRequest.ts
import { base58 as base583, base64, hex as hex2 } from "@scure/base";

// src/utils/multiPayload/webauthn.ts
import { base58 as base582, base64urlnopad as base64urlnopad2 } from "@scure/base";

// src/utils/webAuthn.ts
import { ECDSASigValue } from "@peculiar/asn1-ecc";
import { AsnParser } from "@peculiar/asn1-schema";
import { base58, hex } from "@scure/base";
import { base64urlnopad } from "@scure/base";
import tweetnacl from "tweetnacl";

// src/utils/uint8Array.ts
function concatUint8Arrays(arrays) {
  let pointer = 0;
  const totalLength = arrays.reduce((prev, curr) => prev + curr.length, 0);
  const toReturn = new Uint8Array(totalLength);
  for (const arr of arrays) {
    toReturn.set(arr, pointer);
    pointer += arr.length;
  }
  return toReturn;
}

// src/utils/webAuthn.ts
function parsePublicKey(formattedPublicKey) {
  const curveType = getCurveType(formattedPublicKey);
  switch (curveType) {
    case "p256": {
      let publicKey;
      try {
        publicKey = base58.decode(formattedPublicKey.slice(5));
      } catch (err) {
        throw new Error("Public key is not base58 encoded", { cause: err });
      }
      if (publicKey.length !== 64) {
        throw new Error(
          `Invalid public key size for P-256 curve, it must be 64 bytes, but got ${publicKey.length} bytes`
        );
      }
      return { curveType, publicKey };
    }
    case "ed25519": {
      let publicKey;
      try {
        publicKey = base58.decode(formattedPublicKey.slice(8));
      } catch (err) {
        throw new Error("Public key is not base58 encoded", { cause: err });
      }
      if (publicKey.length !== 32) {
        throw new Error(
          `Invalid public key size for Ed25519 curve, it must be 32 bytes, but got ${publicKey.length} bytes`
        );
      }
      return { curveType, publicKey };
    }
    default:
      throw new Error(`Unsupported curve type ${curveType}`);
  }
}
function getCurveType(formattedPublicKey) {
  const delim = formattedPublicKey.indexOf(":");
  if (delim === -1) {
    throw new Error("Invalid public key format");
  }
  return formattedPublicKey.slice(0, delim);
}
function extractRawSignature(attestationSignature_, curveType) {
  const attestationSignature = new Uint8Array(attestationSignature_);
  switch (curveType) {
    case "ed25519":
      return attestationSignature;
    case "p256": {
      const parsedSignature = AsnParser.parse(
        attestationSignature,
        ECDSASigValue
      );
      let rBytes = new Uint8Array(parsedSignature.r);
      let sBytes = new Uint8Array(parsedSignature.s);
      if (shouldRemoveLeadingZero(rBytes)) {
        rBytes = rBytes.slice(1);
      }
      if (shouldRemoveLeadingZero(sBytes)) {
        sBytes = sBytes.slice(1);
      }
      sBytes = normalizeSignatureS(sBytes);
      return concatUint8Arrays([rBytes, sBytes]);
    }
    default:
      curveType;
      throw new Error(`Unsupported curve type ${curveType}`);
  }
}
function shouldRemoveLeadingZero(bytes) {
  return bytes[0] === 0 && (bytes[1] & 1 << 7) !== 0;
}
function normalizeSignatureS(sBytes) {
  const P256_N = BigInt(
    "0xFFFFFFFF00000000FFFFFFFFFFFFFFFFBCE6FAADA7179E84F3B9CAC2FC632551"
  );
  const P256_N_HALF = P256_N >> 1n;
  const sHex = hex.encode(sBytes);
  const s = BigInt(`0x${sHex}`);
  if (s > P256_N_HALF) {
    const sLow = P256_N - s;
    return hex.decode(sLow.toString(16).padStart(64, "0"));
  }
  return sBytes;
}

// src/utils/multiPayload/webauthn.ts
function makeWebAuthnMultiPayload(userInfo, signature) {
  assert(
    userInfo.userChainType === "webauthn",
    "User chain and signature chain must match"
  );
  const { curveType, publicKey } = parsePublicKey(userInfo.userAddress);
  return {
    standard: "webauthn",
    payload: signature.signedData.payload,
    public_key: formatPublicKey(publicKey, curveType),
    signature: formatSignature(
      extractRawSignature(signature.signatureData.signature, curveType),
      curveType
    ),
    client_data_json: new TextDecoder("utf-8").decode(
      signature.signatureData.clientDataJSON
    ),
    authenticator_data: base64urlnopad2.encode(
      new Uint8Array(signature.signatureData.authenticatorData)
    )
  };
}
function formatPublicKey(publicKey, curveType) {
  return `${curveType}:${base582.encode(publicKey)}`;
}
function formatSignature(signature, curveType) {
  return `${curveType}:${base582.encode(new Uint8Array(signature))}`;
}

// src/utils/prepareBroadcastRequest.ts
function prepareSwapSignedData(signature, userInfo) {
  const signatureType = signature.type;
  switch (signatureType) {
    case "NEP413": {
      return {
        standard: "nep413",
        payload: {
          message: signature.signedData.message,
          nonce: base64.encode(signature.signedData.nonce),
          recipient: signature.signedData.recipient,
          callbackUrl: signature.signedData.callbackUrl
        },
        public_key: signature.signatureData.publicKey,
        // publicKey is already in the correct format
        signature: transformNEP141Signature(signature.signatureData.signature)
      };
    }
    case "ERC191": {
      return {
        standard: "erc191",
        payload: signature.signedData.message,
        signature: transformERC191Signature(signature.signatureData)
      };
    }
    case "SOLANA":
      assert(
        userInfo.userChainType === "solana",
        "User chain and signature chain must match"
      );
      return {
        standard: "raw_ed25519",
        payload: new TextDecoder().decode(signature.signedData.message),
        // Solana address is its public key encoded in base58
        public_key: `ed25519:${userInfo.userAddress}`,
        signature: transformSolanaSignature(signature.signatureData)
      };
    case "WEBAUTHN": {
      return makeWebAuthnMultiPayload(userInfo, signature);
    }
    case "TON_CONNECT": {
      return {
        standard: "ton_connect",
        address: signature.signatureData.address,
        domain: signature.signatureData.domain,
        timestamp: signature.signatureData.timestamp,
        payload: signature.signatureData.payload,
        public_key: `ed25519:${base583.encode(hex2.decode(userInfo.userAddress))}`,
        signature: `ed25519:${base583.encode(base64.decode(signature.signatureData.signature))}`
      };
    }
    default:
      signatureType;
      throw new Error("exhaustive check failed");
  }
}
function transformNEP141Signature(signature) {
  const encoded = base583.encode(base64.decode(signature));
  return `ed25519:${encoded}`;
}
function transformERC191Signature(signature) {
  const normalizedSignature = normalizeERC191Signature(signature);
  const bytes = hex2.decode(
    normalizedSignature.startsWith("0x") ? normalizedSignature.slice(2) : normalizedSignature
  );
  return `secp256k1:${base583.encode(bytes)}`;
}
function normalizeERC191Signature(signature) {
  let v6 = Number.parseInt(signature.slice(-2), 16);
  v6 = toRecoveryBit(v6);
  const vHex = v6.toString(16).padStart(2, "0");
  return signature.slice(0, -2) + vHex;
}
function toRecoveryBit(yParityOrV) {
  if (yParityOrV === 0 || yParityOrV === 1) return yParityOrV;
  if (yParityOrV === 27) return 0;
  if (yParityOrV === 28) return 1;
  throw new Error("Invalid yParityOrV value");
}
function transformSolanaSignature(signature) {
  return `ed25519:${base583.encode(signature)}`;
}

// src/solverRelay/publishIntent.ts
function publishIntent(signatureData, userInfo, quoteHashes) {
  return publishIntents2({
    signed_datas: [prepareSwapSignedData(signatureData, userInfo)],
    quote_hashes: quoteHashes
  }).then((result) => {
    return result.map((intentHashes) => {
      const intentHash = intentHashes[0];
      assert(intentHash != null, "Should include at least one intent hash");
      return intentHash;
    });
  });
}

// src/utils/index.ts
var utils_exports = {};
__export(utils_exports, {
  BASIS_POINTS_DENOMINATOR: () => BASIS_POINTS_DENOMINATOR,
  DuplicateTokenError: () => DuplicateTokenError,
  accountSlippageExactIn: () => accountSlippageExactIn,
  addAmounts: () => addAmounts,
  adjustDecimals: () => adjustDecimals,
  adjustDecimalsTokenValue: () => adjustDecimalsTokenValue,
  authHandleToIntentsUserId: () => authHandleToIntentsUserId,
  compareAmounts: () => compareAmounts,
  computeTotalBalance: () => computeTotalBalance,
  computeTotalBalanceDifferentDecimals: () => computeTotalBalanceDifferentDecimals,
  computeTotalDeltaDifferentDecimals: () => computeTotalDeltaDifferentDecimals,
  deduplicateTokens: () => deduplicateTokens,
  filterOutPoaBridgeTokens: () => filterOutPoaBridgeTokens,
  getAnyBaseTokenInfo: () => getAnyBaseTokenInfo,
  getDerivedToken: () => getDerivedToken,
  getTokenAccountId: () => getTokenAccountId,
  getTokenAccountIds: () => getTokenAccountIds,
  getTokenMaxDecimals: () => getTokenMaxDecimals,
  getUnderlyingBaseTokenInfos: () => getUnderlyingBaseTokenInfos,
  grossUpAmount: () => grossUpAmount,
  minAmounts: () => minAmounts,
  negateTokenValue: () => negateTokenValue,
  netDownAmount: () => netDownAmount,
  normalizeERC191Signature: () => normalizeERC191Signature,
  parseDefuseAssetId: () => parseDefuseAssetId,
  prepareSwapSignedData: () => prepareSwapSignedData,
  subtractAmounts: () => subtractAmounts,
  tokenAccountIdToDefuseAssetId: () => tokenAccountIdToDefuseAssetId,
  transformERC191Signature: () => transformERC191Signature,
  truncateTokenValue: () => truncateTokenValue
});

// src/utils/authIdentity.ts
import { keccak_256 } from "@noble/hashes/sha3";
import { base58 as base584, hex as hex3 } from "@scure/base";
function authHandleToIntentsUserId(authIdentifier, authMethod) {
  let authHandle;
  if (typeof authIdentifier === "object") {
    authHandle = authIdentifier;
  } else if (authMethod != null) {
    authHandle = {
      identifier: authIdentifier,
      method: authMethod
    };
  } else {
    throw new Error("Invalid arguments");
  }
  const method = authHandle.method;
  switch (method) {
    case "evm":
    case "near":
      return authHandle.identifier.toLowerCase();
    case "solana":
      return hex3.encode(base584.decode(authHandle.identifier));
    case "webauthn": {
      return webAuthnIdentifierToIntentsUserId(
        authHandle.identifier
      );
    }
    case "ton": {
      assert(authHandle.identifier.length === 64);
      hex3.decode(authHandle.identifier);
      return authHandle.identifier.toLowerCase();
    }
    default:
      method;
      throw new Error("Unsupported auth method");
  }
}
function webAuthnIdentifierToIntentsUserId(credential) {
  const { curveType, publicKey } = parsePublicKey(credential);
  switch (curveType) {
    case "p256": {
      const p256 = new TextEncoder().encode("p256");
      const addressBytes = keccak_256(
        new Uint8Array([...p256, ...publicKey])
      ).slice(-20);
      return "0x" + hex3.encode(addressBytes);
    }
    case "ed25519": {
      return hex3.encode(publicKey);
    }
    default:
      curveType;
      throw new Error("Unsupported curve type");
  }
}

// src/utils/near.ts
import * as v4 from "valibot";
import { isAddress } from "viem";
function decodeQueryResult(response, schema) {
  const parsed = v4.parse(v4.object({ result: v4.array(v4.number()) }), response);
  const uint8Array = new Uint8Array(parsed.result);
  const decoder = new TextDecoder();
  const result = decoder.decode(uint8Array);
  return v4.parse(schema, JSON.parse(result));
}
var ACCOUNT_ID_REGEX = /^(([a-z\d]+[-_])*[a-z\d]+\.)*([a-z\d]+[-_])*[a-z\d]+$/;
function isLegitAccountId(accountId) {
  if (isAddress(accountId) && accountId === accountId.toLowerCase()) {
    return true;
  }
  return ACCOUNT_ID_REGEX.test(accountId);
}

// src/utils/token.ts
function isBaseToken(token) {
  return "defuseAssetId" in token;
}

// src/utils/tokenUtils.ts
function computeTotalBalance(token, balances) {
  if (Array.isArray(token)) {
    const uniqueTokens = new Set(token);
    let total = 0n;
    for (const tokenId of uniqueTokens) {
      const balance = balances[tokenId];
      if (balance == null) {
        return void 0;
      }
      total += balance;
    }
    return total;
  }
  if (isBaseToken(token)) {
    return balances[token.defuseAssetId];
  }
  return computeTotalBalance(
    token.groupedTokens.map((t) => t.defuseAssetId),
    balances
  );
}
var DuplicateTokenError = class extends Error {
  constructor(tokenId, decimals1, decimals2) {
    super(
      `Duplicate token ${tokenId} found with different decimals: ${decimals1} and ${decimals2}`
    );
    this.name = "DuplicateTokenError";
  }
};
function adjustDecimals(amount, fromDecimals, toDecimals) {
  if (fromDecimals === toDecimals) return amount;
  if (fromDecimals > toDecimals) {
    return amount / BigInt(10 ** (fromDecimals - toDecimals));
  }
  return amount * BigInt(10 ** (toDecimals - fromDecimals));
}
function deduplicateTokens(tokens) {
  const tokenMap = /* @__PURE__ */ new Map();
  for (const token of tokens) {
    const existing = tokenMap.get(token.defuseAssetId);
    if (existing) {
      if (existing.decimals !== token.decimals) {
        throw new DuplicateTokenError(
          token.defuseAssetId,
          existing.decimals,
          token.decimals
        );
      }
      continue;
    }
    tokenMap.set(token.defuseAssetId, token);
  }
  return Array.from(tokenMap.values());
}
function computeTotalBalanceDifferentDecimals(token, balances, config2 = { strict: true }) {
  if (!Array.isArray(token) && isBaseToken(token)) {
    token = [token];
  }
  const uniqueTokens = deduplicateTokens(
    Array.isArray(token) ? token : token.groupedTokens
  );
  if (uniqueTokens.length === 0) {
    return { amount: 0n, decimals: 0 };
  }
  const maxDecimals = Math.max(...uniqueTokens.map((t) => t.decimals));
  let total = null;
  for (const t of uniqueTokens) {
    const balance = balances[t.defuseAssetId];
    if (balance == null) {
      if (config2.strict) {
        return void 0;
      }
      continue;
    }
    total ?? (total = 0n);
    total += adjustDecimals(balance, t.decimals, maxDecimals);
  }
  if (total == null) {
    return void 0;
  }
  return { amount: total, decimals: maxDecimals };
}
function computeTotalDeltaDifferentDecimals(tokens, tokenDeltas) {
  const mapping = {};
  for (const [token, amount] of tokenDeltas) {
    mapping[token] ?? (mapping[token] = 0n);
    mapping[token] += amount;
  }
  return computeTotalBalanceDifferentDecimals(tokens, mapping, {
    strict: false
  }) ?? { amount: 0n, decimals: 0 };
}
function getAnyBaseTokenInfo(token) {
  const t = getUnderlyingBaseTokenInfos(token)[0];
  assert(t != null, "Token is undefined");
  return t;
}
function getUnderlyingBaseTokenInfos(token) {
  let tokens;
  if (Array.isArray(token)) {
    tokens = token;
  } else {
    tokens = isBaseToken(token) ? [token] : token.groupedTokens;
  }
  return deduplicateTokens(tokens);
}
function getDerivedToken(tokenIn, chainName) {
  if (isBaseToken(tokenIn)) {
    return chainName === tokenIn.chainName ? tokenIn : null;
  }
  if (chainName != null) {
    const tokenOut = tokenIn.groupedTokens.find(
      (token) => token.chainName === chainName
    );
    if (tokenOut != null) {
      return tokenOut;
    }
  }
  return null;
}
function getTokenMaxDecimals(token) {
  const tokens = getUnderlyingBaseTokenInfos(token);
  return Math.max(...tokens.map((t) => t.decimals));
}
function compareAmounts(value1, value2) {
  const maxDecimals = Math.max(value1.decimals, value2.decimals);
  const normalizedAmount1 = adjustDecimals(
    value1.amount,
    value1.decimals,
    maxDecimals
  );
  const normalizedAmount2 = adjustDecimals(
    value2.amount,
    value2.decimals,
    maxDecimals
  );
  if (normalizedAmount1 < normalizedAmount2) return -1;
  if (normalizedAmount1 > normalizedAmount2) return 1;
  return 0;
}
function minAmounts(value1, value2) {
  return compareAmounts(value1, value2) <= 0 ? value1 : value2;
}
function addAmounts(...values) {
  const maxDecimals = Math.max(...values.map((v6) => v6.decimals));
  let sum = 0n;
  for (const v6 of values) {
    sum += adjustDecimals(v6.amount, v6.decimals, maxDecimals);
  }
  return {
    amount: sum,
    decimals: maxDecimals
  };
}
function subtractAmounts(value1, token2) {
  return addAmounts(value1, {
    amount: -token2.amount,
    decimals: token2.decimals
  });
}
function adjustDecimalsTokenValue(value, toDecimals) {
  return {
    amount: adjustDecimals(value.amount, value.decimals, toDecimals),
    decimals: toDecimals
  };
}
function truncateTokenValue(value, decimals) {
  return adjustDecimalsTokenValue(
    adjustDecimalsTokenValue(value, decimals),
    value.decimals
  );
}
function negateTokenValue(value) {
  return {
    amount: -value.amount,
    decimals: value.decimals
  };
}
var BASIS_POINTS_DENOMINATOR = 1000000n;
function netDownAmount(amount, feeBip) {
  if (feeBip < 0 || feeBip > Number(BASIS_POINTS_DENOMINATOR)) {
    throw new Error(
      `Invalid feeBip value. It must be between 0 and ${BASIS_POINTS_DENOMINATOR}.`
    );
  }
  if (amount < 0n) {
    throw new Error("Amount must be non-negative.");
  }
  if (amount === 0n || feeBip === 0) return amount;
  const feeAmount = (amount * BigInt(feeBip) + (BASIS_POINTS_DENOMINATOR - 1n)) / BASIS_POINTS_DENOMINATOR;
  return amount - feeAmount;
}
function grossUpAmount(amount, feeBip) {
  if (feeBip < 0 || feeBip > Number(BASIS_POINTS_DENOMINATOR)) {
    throw new Error(
      `Invalid feeBip value. It must be between 0 and ${BASIS_POINTS_DENOMINATOR}.`
    );
  }
  if (amount < 0n) {
    throw new Error("Amount must be non-negative.");
  }
  if (amount === 0n || feeBip === 0) return amount;
  const feeMultiplier = BASIS_POINTS_DENOMINATOR - BigInt(feeBip);
  const grossAmount = (amount * BASIS_POINTS_DENOMINATOR + (feeMultiplier - 1n)) / feeMultiplier;
  return grossAmount;
}
function accountSlippageExactIn(delta, slippageBasisPoints) {
  return delta.map(([token, amount]) => {
    if (amount > 0n) {
      const amountWithSlippage = netDownAmount(amount, slippageBasisPoints);
      return [token, amountWithSlippage];
    }
    return [token, amount];
  });
}
function filterOutPoaBridgeTokens(token) {
  if (isBaseToken(token)) {
    return token.bridge === "poa" ? [token] : [];
  }
  return token.groupedTokens.filter((t) => t.bridge === "poa");
}
function getTokenAccountIds(tokens) {
  return tokens.map((t) => getTokenAccountId(t.defuseAssetId));
}
function getTokenAccountId(assetId) {
  const { contractId } = parseDefuseAssetId(assetId);
  return contractId;
}
function parseDefuseAssetId(assetId) {
  const [tokenStandard, tokenContractId, multiTokenId] = assetId.split(":");
  assert(
    tokenContractId != null && isLegitAccountId(tokenContractId),
    "Incorrect format of assetId"
  );
  switch (tokenStandard) {
    case "nep141":
      return {
        standard: "nep141",
        contractId: tokenContractId
      };
    case "nep245": {
      assert(multiTokenId != null, "Incorrect NEP-245 token format");
      return {
        standard: "nep245",
        contractId: tokenContractId,
        tokenId: multiTokenId
      };
    }
    default:
      assert(false, `Unsupported token standard: ${tokenStandard}`);
  }
}
function tokenAccountIdToDefuseAssetId(address) {
  return `nep141:${address}`;
}

// src/errors/index.ts
var errors_exports = {};
__export(errors_exports, {
  toError: () => toError
});

// src/services/blockchainBalanceService.ts
import { base64 as base642 } from "@scure/base";
import * as v5 from "valibot";
var getNearNep141StorageBalance = async ({
  contractId,
  accountId,
  nearProvider
}) => {
  try {
    const args = { account_id: accountId };
    const argsBase64 = Buffer.from(JSON.stringify(args)).toString("base64");
    const response = await nearProvider.query({
      request_type: "call_function",
      method_name: "storage_balance_of",
      account_id: contractId,
      args_base64: argsBase64,
      finality: "optimistic"
    });
    const parsed = decodeQueryResult(
      response,
      v5.union([v5.null(), v5.object({ total: v5.string() })])
    );
    return BigInt(parsed?.total || "0");
  } catch (err) {
    throw new Error("Error fetching balance", { cause: err });
  }
};
var getNearNep141MinStorageBalance = async ({
  contractId,
  nearProvider
}) => {
  const response = await nearProvider.query({
    request_type: "call_function",
    method_name: "storage_balance_bounds",
    account_id: contractId,
    args_base64: base642.encode(new TextEncoder().encode(JSON.stringify({}))),
    finality: "optimistic"
  });
  const parsed = decodeQueryResult(
    response,
    v5.object({ min: v5.string(), max: v5.string() })
  );
  return BigInt(parsed.min);
};

// src/utils/failover.ts
import { providers } from "near-api-js";
function nearFailoverRpcProvider({ urls }) {
  const providers_ = urls.map((url) => new providers.JsonRpcProvider({ url }));
  return createNearFailoverRpcProvider({ providers: providers_ });
}
function createNearFailoverRpcProvider({
  providers: list
}) {
  return new providers.FailoverRpcProvider(list);
}

// src/nearClient.ts
var PUBLIC_NEAR_RPC_URLS = [
  "https://nearrpc.aurora.dev",
  "https://free.rpc.fastnear.com",
  "https://rpc.mainnet.near.org"
];
var nearClient = nearFailoverRpcProvider({
  urls: PUBLIC_NEAR_RPC_URLS
});
export {
  BaseError,
  BlockchainEnum,
  PUBLIC_NEAR_RPC_URLS,
  RETRY_CONFIGS,
  config,
  configsByEnvironment,
  configureSDK,
  errors_exports as errors,
  getNearNep141MinStorageBalance,
  getNearNep141StorageBalance,
  nearFailoverRpcProvider,
  poaBridge_exports as poaBridge,
  request,
  serialize,
  solverRelay_exports as solverRelay,
  utils_exports as utils,
  withTimeout
};
